import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-seller-section',
  templateUrl: './top-seller-section.component.html',
  styleUrls: ['./top-seller-section.component.scss']
})
export class TopSellerSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
